import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FlatsFiltersChips from '../FlatsFiltersChips/FlatsFiltersChips';
import { FlatsFiltersContentContext } from '../FlatsFiltersContext';

const FlatsFiltersSection = ({ filterParams: { name, title, options }, className }) => {
  const { searchParams, updateSearchParams } = useContext(FlatsFiltersContentContext);
  const [active, setActive] = useState(searchParams[name]);
  const toggleActive = (value, isActive) => {
    let nextActive;
    if (isActive) {
      nextActive = [...active, value];
    } else {
      nextActive = active.filter((v) => v !== value);
    }

    updateSearchParams({
      ...searchParams,
      [name]: nextActive,
    });
    setActive(active);
  };

  useEffect(() => {
    setActive(searchParams[name]);
  }, [searchParams, name]);

  return (
    <div className={cx('FlatsFiltersSection', className)}>
      <div className="FlatsFiltersSection-title">{title}</div>
      <div className="FlatsFiltersSection-chips">
        {options.map((item) => (
          <FlatsFiltersChips
            key={`${name}_${item.value}`}
            item={item}
            name={name}
            onClick={toggleActive}
          />
        ))}
      </div>
    </div>
  );
};

FlatsFiltersSection.propTypes = {
  filterParams: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default FlatsFiltersSection;
